import { cn } from '@avanta/shared/utils/cn';
import { textStyles } from './styles';
import { type TextProps } from './types';

const getTag = (
  variant: TextProps['variant'],
  tag?: TextProps['tag']
): keyof React.JSX.IntrinsicElements => {
  if (tag) return tag;
  if (variant?.startsWith('heading')) return 'h2';
  return 'p';
};

export const Text = ({ children, className, tag, variant }: TextProps): React.ReactElement => {
  const Component = getTag(variant, tag);
  return <Component className={cn(textStyles({ variant, className }))}>{children}</Component>;
};
